import { keyframes } from "styled-components";

export const gradient = "linear-gradient(144.01deg, #ffc951 0%, #c94daa 130%)";

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const shimmer = keyframes`
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
`;

/**
 * Marketplace Global Constants & Design Tokens
 */

export const MARKETPLACE_COLORS = {
  // Brand Gradients & Accents
  BRAND_GRADIENT: "linear-gradient(95.57deg, #FFC951 0%, #C94DAA 100%)",
  HERO_BTN_GRADIENT: "linear-gradient(106.11deg, #FFC951 0%, #C94DAA 100%)",
  ICON_GRADIENT: "linear-gradient(135deg, #FFC951 0%, #C94DAA 100%)",
  LIGHT_BRAND_GRADIENT: "linear-gradient(95.57deg, #FFD573 0%, #D863BA 100%)",
  LIGHT_HERO_BTN_GRADIENT: "linear-gradient(106.11deg, #FFD573 0%, #D863BA 100%)",
  LIGHT_ICON_GRADIENT: "linear-gradient(135deg, #FFD573 0%, #D863BA 100%)",

  // Solid Accent Colors
  GOLD: "#FFC951",
  PINK: "#C94DAA",
  LIGHT_GOLD: "#FFD573",
  LIGHT_PINK: "#D863BA",
  STAR_YELLOW: "#f59e0b",
  
  // Theme Text Colors
  TEXT_LIGHT_HEADING: "#E2E2E5",
  TEXT_MUTED_GOLD: "#D2C5AF",
  TEXT_WHITE: "#FFFFFF",
  TEXT_DARK_TITLE: "#171717",
  
  // Theme Backgrounds
  DARK_PAGE_BG: "#0b0c0d",
  DARK_SECTION_BG: "#1A1C1E",
  DARK_CARD_BG: "#15181b",
  DARK_FORM_BG: "#1E2022",
  DARK_FLOATING_CARD_BG: "#171717",
} as const;

export const MARKETPLACE_FONTS = {
  SERIF: "Liberation Serif, Georgia, serif",
  SANS: "Montserrat, sans-serif",
} as const;
